export const ChevronDownIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Expand",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="chevron-down-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <title>{title}</title>
      <path
        d="M7 10L12 15L17 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
